import React from 'react';
import { Route, Routes } from 'react-router-dom';
import IdentitiesOverview from '../components/IdentitiesOverview';

const IdentitiesScene = () => (
  <Routes>
    <Route index element={<IdentitiesOverview />} />
  </Routes>
);

export default IdentitiesScene;
